export class LabelValueObj {
    id: number;
    label: any;
    value: any;

    constructor() {
        this.id = -1;
        this.label = '';
        this.value = '';
    }
}